import { render, staticRenderFns } from "./EmployeeApp.vue?vue&type=template&id=4b5e8a03&scoped=true"
import script from "./EmployeeApp.vue?vue&type=script&lang=js"
export * from "./EmployeeApp.vue?vue&type=script&lang=js"
import style0 from "./EmployeeApp.vue?vue&type=style&index=0&id=4b5e8a03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e8a03",
  null
  
)

export default component.exports